export default "__VITE_ASSET__a8edfbc4__"